import { useState, useEffect } from "react"
import type { FC } from "react"
import postsApi from "../../../../services/postsApi"
import type { Tag } from "../../models/posts"

interface PostFilterProps {
  type: number
  query: string
  selectedTags: number[]
  onQueryChange: (q: string) => void
  onSearch: () => void
  onAddTag: (tagId: number) => void
  onRemoveTag: (tagId: number) => void
}

const PostFilter: FC<PostFilterProps> = ({
  type,
  query,
  selectedTags,
  onQueryChange,
  onSearch,
  onAddTag,
  onRemoveTag,
}) => {
  const [show, setShow] = useState(false)
  const [tags, setTags] = useState<Tag[]>([])

  useEffect(() => {
    postsApi.getTags(type).then(setTags)
  }, [type])

  return (
    <div className="bg-white rounded-lg mb-4 border border-gray-200">
      <div className="text-center py-2">
        {!show ? (
          <button className="text-sm text-gray-500 hover:text-gray-700" onClick={() => setShow(true)}>
            <i className="fa fa-search mr-1" /> Pesquisa
          </button>
        ) : (
          <div className="p-3">
            <div className="flex gap-2 mb-3">
              <input
                type="text"
                className="flex-1 border border-gray-200 rounded px-3 py-1.5 text-sm focus:outline-none focus:border-blue-300"
                placeholder="Pesquisa"
                value={query}
                onChange={(e) => onQueryChange(e.target.value)}
              />
              <button className="bg-gray-100 text-gray-700 px-3 py-1.5 rounded text-sm hover:bg-gray-200" onClick={onSearch}>
                Pesquisar
              </button>
            </div>
            <div className="flex flex-wrap gap-1">
              {tags.map((tag) => {
                const selected = selectedTags.includes(tag.id)
                return (
                  <button
                    key={tag.id}
                    className={`px-2 py-0.5 text-xs rounded-full border ${
                      selected
                        ? "bg-blue-100 text-blue-700 border-blue-200"
                        : "bg-gray-50 text-gray-500 border-gray-200 hover:bg-gray-100"
                    }`}
                    onClick={() => (selected ? onRemoveTag(tag.id) : onAddTag(tag.id))}
                  >
                    {tag.name}
                  </button>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PostFilter